import React from 'react';
import { useNavigate } from 'react-router-dom';
import RadioInput from '../../components/RadioButton';
import Button from '../../components/Button';
import { useDispatch } from 'react-redux';
import './anti-depressant-prescription.scss';
import { updatePersonalForm } from '../../core/actions';

const AntiDepressantPrescription: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [value, setValue] = React.useState<any>(null);

    function onChanged(value: any) {
        setValue(value);
    }

    function onSubmitted() {
        dispatch(updatePersonalForm('anti_depressant_prescription', value));
        if (value === 'between_two_and_four' || value === 'five_or_above') {
            navigate('/non-drug-treatment', { replace: true });
        } else {
            navigate('/suicide-attempt', { replace: true });
        }
    }

    return (
        <div className="anti-depressant-prescription">
            <h1 className="anti-depressant-prescription__title">{`How many anti-depressant prescription medications do you currently take or have tried in the past?`}</h1>
            <RadioInput id={'zero'} label={'0'} groupValue={value} onChange={onChanged} value={'zero'} />
            <RadioInput id={'one'} label={'1'} groupValue={value} onChange={onChanged} value={'one'} />
            <RadioInput id={'between_two_and_four'} label={'2-4'} groupValue={value} onChange={onChanged} value={'between_two_and_four'} />
            <RadioInput id={'five_or_above'} label={'5+'} groupValue={value} onChange={onChanged} value={'five_or_above'} />
            <RadioInput id={'not_shure'} label={'Not Sure'} groupValue={value} onChange={onChanged} value={'not_shure'} />
            <div style={{ marginTop: 16 }}>
                <Button type='primary' onPressed={onSubmitted} disabled={!value}>
                    {'Continue'}
                </Button>
            </div>
        </div>
    );
}

export default AntiDepressantPrescription;
